<template>
  <div
    v-if="questionnaire"
    class="plv-ia-qn-detail"
  >
    <div v-show="isLoading" class="plv-ia-qn-detail-loading">
      <span>Loading...</span>
    </div>
    <div class="plv-ia-qn-detail__body">
      <div class="plv-ia-qn-detail__body__wrap">
        <h1 class="plv-ia-qn-detail-name">{{ questionnaire.name }}</h1>

        <template v-if="questionnaire">
          <DetailQuestion
            v-for="(question, index) in questionnaire.questions"
            :key="question.questionId"
            :question="question"
            :question-index="index"
            :status="questionnaire.status"
            :statistics="getStatisticsQuestion(question.questionId)"
          />
        </template>

        <!-- 隐私协议checkbox纯展示 -->
        <template v-if="questionnaire.privacy && questionnaire.privacy.required === 'Y'">
          <PrivacyCheckbox
            class="plv-ia-qn-detail__body__wrap__privacy-checkbox"
            :checked="false"
            :disabled="true"
            :content="questionnaire.privacy.content"
          />
        </template>
      </div>
    </div>

    <div class="plv-ia-qn-detail__footer">
      <div class="plv-ia-clearfix">
        <div class="plv-ia-fl">
          <p class="plv-ia-qn-detail__footer__tips">{{ t('plvIA.questionnaire.publishTips') }}</p>
        </div>
        <div class="plv-ia-fr">
          <span v-if="isOnGoing" class="plv-ia-qn-detail__footer__count">{{ t('plvIA.questionnaire.respond') }}<span class="plv-ia-qn-detail-num pws-vclass-qn-txt-blue">{{ pushNum }}</span>{{ t('plvIA.questionnaire.count') }}</span>
          <span v-else-if="isFinished && statistics" class="plv-ia-qn-detail__footer__count">{{ t('plvIA.questionnaire.totalSubmission') }}<span class="plv-ia-qn-detail-num pws-vclass-qn-txt-blue">{{ statistics.total }}</span>{{ t('plvIA.questionnaire.person') }}</span>
        </div>
      </div>
      <div class="plv-ia-clearfix">
        <template v-if="isOnGoing">
          <div class="plv-ia-fl">
            <button class="plv-ia-btn-new plv-ia-btn-orange pws-vclass-btn-orange" :disabled="isStopping" @click="handleStopBtnClick">{{ t('plvIA.questionnaire.stop') }}</button>
          </div>
        </template>

        <template v-else-if="isFinished">
          <div class="plv-ia-fl">
            <button
              class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue"
              :disabled="isSentResult"
              @click="handleResultBtnClick"
            >
              {{ !isSentResult ? t('plvIA.questionnaire.sendResult') : t('plvIA.common.sent') }}
            </button>
            <span
              class="plv-ia-btn-new pws-vclass-btn-new"
              @click="downloadResult"
            >
              {{ t('plvIA.questionnaire.downloadResult') }}
            </span>
            <button
              class="plv-ia-btn-new pws-vclass-btn-new"
              :disabled="!hasQuestions"
              @click="handlePublishBtnClick"
            >
              {{ t('plvIA.questionnaire.republish') }}
            </button>
          </div>
          <div class="plv-ia-fr">
            <button
              class="plv-ia-btn-new pws-vclass-btn-new"
              @click="handleDelBtnClick"
            >
              {{ t('plvIA.common.delete') }}
            </button>
          </div>
        </template>

        <template v-else>
          <div class="plv-ia-fl">
            <button
              class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue"
              :disabled="!hasQuestions"
              @click="handlePublishBtnClick"
            >
              {{ t('plvIA.questionnaire.publish') }}
            </button>
          </div>
          <div class="plv-ia-fr">
            <button
              class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue"
              @click="handleEditBtnClick"
            >
              {{ t('plvIA.questionnaire.edit') }}
            </button>
            <button
              class="plv-ia-btn-new pws-vclass-btn-new"
              @click="handleDelBtnClick"
            >
              {{ t('plvIA.common.delete') }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { debounce } from 'lodash-es';
import DetailQuestion from './DetailQuestion';
import { STATUS } from './helper';
import PrivacyCheckbox from '@/components/privacy-checkbox/index.vue';

export default {
  name: 'QuestionnaireDetail',
  components: {
    DetailQuestion,
    PrivacyCheckbox
  },
  mixins: [Locale],

  props: {
    isStopping: Boolean,

    isLoading: {
      type: Boolean,
      default: false,
    },

    questionnaire: {
      type: Object,
      default: null
    },

    // 已回收 n 份问卷
    pushNum: {
      type: Number,
      default: 0,
    },

    // 已发送问卷结果
    isSentResult: Boolean,
  },

  computed: {
    statistics() {
      return this.questionnaire && this.questionnaire.statistics;
    },

    isOnGoing() {
      return this.questionnaire.status === STATUS.SENDED;
    },

    isFinished() {
      return this.questionnaire.status === STATUS.FINISHED;
    },

    hasQuestions() {
      return this.questionnaire && this.questionnaire.questions;
    }
  },

  methods: {
    getStatisticsQuestion(questionId) {
      return this.statistics && (this.statistics.questions.find(item => item.questionId === questionId) || { total: 0 });
    },
    downloadResult() {
      if (!this.questionnaire) return '';
      const questionnaireId = this.questionnaire.questionnaireId;
      this.$emit('download-statistics', questionnaireId);
    },
    handleEditBtnClick() {
      this.$emit('edit');
    },

    handleDelBtnClick() {
      this.$emit('delete');
    },

    handlePublishBtnClick: debounce(function() {
      this.$emit('publish');
    }, 300),

    handleResultBtnClick: debounce(function() {
      if (this.hasQuestions && this.questionnaire.questions.filter(item => item.isScorable).length <= 0) {
        this.$iaMessage.default(this.t('plvIA.questionnaire.noAnswer'));
        return;
      }
      this.$emit('result');
    }, 300),

    handleStopBtnClick: debounce(function() {
      this.$emit('stop');
    }, 300),
  }
};
</script>

<style lang="scss">
$blue: #45ACFF;

.plv-ia-qn-detail {
  width: 100%;
  height: 100%;
  position: relative;
}

.plv-ia-qn-detail__body {
  font-size: 14px;
  color: #2c2c2c;
  padding-bottom: 124px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
}

.plv-ia-qn-detail__body__wrap {
  height: 100%;
  overflow: auto;
  padding: 0 24px;
  padding-top: 26px;
  box-sizing: border-box;
}

.plv-ia-qn-detail-num {
  font-size: 18px;
  color: $blue;
  padding: 0 .2em;
  font-weight: bold;
  line-height: 1;
}

.plv-ia-qn-detail-name {
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 25px;
  word-break: break-all;
  line-height: 1.5;
  padding: 0 35px;
}

.plv-ia-qn-detail__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;

  .plv-ia-clearfix {
    position: relative;

    &:first-child {
      margin-bottom: 24px;
      line-height: 20px;
      height: 20px;
    }
  }

  .plv-ia-fl, .plv-ia-fr {
    font-size: 0;

    .plv-ia-btn-new:first-child {
      margin-left: 0;
    }
  }

  .plv-ia-fl .plv-ia-btn-new {
    margin-left: 8px;
  }

  .plv-ia-fr .plv-ia-btn-new {
    margin-left: 16px;
  }

  .plv-ia-fr .plv-ia-btn-new {
    width: 64px;
  }

  .plv-ia-fr span {
    font-size: 14px;
  }
}

.plv-ia-qn-detail__footer__tips {
  font-size: 12px;
  color: #757575;
  text-align: left;
  padding-left: 20px;
  position: relative;

  &::before {
    content: '';
    width: 14px;
    height: 14px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: url(./images/icon-warning.png) no-repeat;
    background-size: contain;
  }
}

.plv-ia-qn-detail__footer__count {
  color: #333;
}

@keyframes plvIaQuestionnaireLoading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.plv-ia-qn-detail-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#EDF1F7, 0.5);
  z-index: 999;

  span {
    font-size: 10px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-indent: -9999em;
    border: 5px solid rgba(#2196f3, 0.3);
    border-left-color: #2196f3;
    transform: translateZ(0);
    animation: plvIaQuestionnaireLoading 1.1s infinite linear;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
}

.plv-ia-qn-detail__body__wrap__privacy-checkbox {
  margin-top: 10px;
}
</style>
